import { PDFStoreProps } from '../stores/pdf.store'
import { encodeBoundaryKey } from './boundaryKey'

export const findBoundaryFromField = (
  state: PDFStoreProps,
  field: { document_id: string; page: number }
) => {
  console.log('state.documents', state.documents, 'field', field)

  const document = state.documents.find((d) => d.id === field.document_id)!
  const page = document.pages.find((p) => p.page === field.page)!
  return state.boundaries[encodeBoundaryKey(page)]!
}
